import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";
import logo from "../assets/Logo-AMIToken.png";

const NavBar = () => {
  const [nav, setNav] = useState(false);

  const links = [
    {
      id: 1,
      link: "home",
      content: "home",
    },
    {
      id: 2,
      link: "background",
      content: "background",
    },
    {
      id: 3,
      link: "project",
      content: "project",
    },
    {
      id: 4,
      link: "token",
      content: "FST token",
    },
    {
      id: 5,
      link: "roadmap",
      content: "roadmap",
    },
    {
      id: 6,
      link: "presale",
      content: "presale",
    },
    {
      id: 7,
      link: "conclusion",
      content: "conclusion",
    },
  ];

  return (
    <div className="flex justify-between items-center w-full h-20 px-4 text-white rounded-md backdrop-brightness-90 bg-transparent backdrop-blur-sm z-50 fixed">
      <div className="flex flex-row align-middle items-center">
        <img src={logo} className="w-10 h-10 mr-3" />
        <h1 className="text-xl font-bold ml-2">Future School Token</h1>
      </div>

      <ul className="hidden lg:flex">
        {links.map(({ id, link, content }) => (
          <li
            key={id}
            className="px-4 cursor-pointer capitalize font-medium text-white hover:scale-105 duration-200"
          >
            <Link to={link} smooth duration={500}>
              {content}
            </Link>
          </li>
        ))}
      </ul>

      <div
        onClick={() => setNav(!nav)}
        className="cursor-pointer pr-4 z-10 text-white lg:hidden"
      >
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      {nav && (
        <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-gray-800 text-gray-500">
          {links.map(({ id, link, content }) => (
            <li
              key={id}
              className="px-4 cursor-pointer capitalize py-6 text-4xl"
            >
              <Link
                onClick={() => setNav(!nav)}
                to={link}
                smooth
                duration={500}
              >
                {content}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NavBar;
